import RegionWrapper from './RegionWrapper';

export default RegionWrapper;
